var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13261_48071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 23.7049C7.75746 24.8843 8.59977 26.1267 9.35288 27.423C9.99585 28.6421 10.2639 29.4688 10.7338 30.9377C11.0219 31.7493 11.2824 31.9916 11.8423 31.9916C12.4525 31.9916 12.7294 31.5795 12.9432 30.9422C13.3874 29.5549 13.7359 28.4962 14.2858 27.4959C15.3647 25.5645 16.7054 23.8483 18.0227 22.1989C18.3793 21.732 20.6851 19.0124 21.7231 16.8664C21.7231 16.8664 22.9989 14.5092 22.9989 11.217C22.9989 8.13751 21.7407 6.00171 21.7407 6.00171L18.1183 6.97182L15.9184 12.7659L15.3741 13.5649L15.2653 13.7096L15.1206 13.8908L14.8665 14.1802L14.5034 14.5432L12.5444 16.1392L7.64677 18.967L6.83203 23.7049Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 16.4703C2.97268 19.2006 5.27772 21.6006 6.83727 23.7069L15.1207 13.8947C15.1207 13.8947 13.9537 15.4209 11.8369 15.4209C9.47888 15.4209 7.57397 13.538 7.57397 11.1637C7.57397 9.53551 8.5535 8.41699 8.5535 8.41699L2.93048 9.9237L1.77734 16.4703Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 0.504639C17.9644 1.39166 20.3191 3.25385 21.7434 5.99983L15.1233 13.8889C15.1233 13.8889 16.1028 12.7502 16.1028 11.1321C16.1028 8.70257 14.057 6.88755 11.8469 6.88755C9.75695 6.88755 8.55664 8.41125 8.55664 8.41125V3.44123L15.2133 0.504639Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29492 3.99041C4.93808 2.02446 7.82942 0 11.8156 0C13.7495 0 15.2065 0.507728 15.2065 0.507728L8.55051 8.41556H3.83465L3.29492 3.99041Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77742 16.4702C1.77742 16.4702 0.677734 14.3167 0.677734 11.1969C0.677734 8.24831 1.82398 5.67087 3.29485 3.99048L8.55418 8.41633L1.77742 16.4702Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13261_48071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3215,
    height: 32,
    fill: "white",
    transform: "translate(0.677734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/GoogleMap.50a04bc98e2e3adb39e15eec70ac5e70.svg";
export { ForwardRef as ReactComponent };